import React from "react";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

// import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
// import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ArrowForwardIcon from "@mui/icons-material/ArrowBack";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
// import StarBorder from "@mui/icons-material/StarBorder";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

import { makeGetRequest } from "../utils/utils.js";
import { ListItem } from "@mui/material";
// import Box from "@mui/material/Box";

function Left() {
  const [, setSelectedIndex] = React.useState(0);

  const handleListItemClick = (event, index) => {
    localStorage.setItem("selectedIndex", index);
    setUpload(!Upload);
    setSelectedIndex(index);
  };

  const navigate = useNavigate();

  const menuSlide = () => {
    var element = document.getElementById("myLeft");
    element.classList.toggle("smoothSlide");
  };

  const leftPnlClose = () => {
    var element = document.getElementById("myLeft");
    element.classList.remove("smoothSlide");
  };

  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  // const [open2, setOpen2] = React.useState(false);

  // const handleClick2 = () => {
  //   setOpen2(!open2);
  // };

  const [open3] = React.useState(false);

  // const handleClick3 = () => {
  //   setOpen3(!open3);
  // };

  // const [open4, setOpen4] = React.useState(false);

  // const handleClick4 = () => {
  //   setOpen4(!open4);
  // };

  const [open5, setOpen5] = React.useState(false);

  const handleClick5 = () => {
    setOpen5(!open5);
  };

  // const [open6, setOpen6] = React.useState(false);

  // const handleClick6 = () => {
  //   setOpen6(!open6);
  // };

  // const [open7, setOpen7] = React.useState(false);

  // const handleClick7 = () => {
  //   setOpen7(!open7);
  // };

  async function logoutUser() {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  }

  const [showConfigureSociety] = React.useState(true);
  const [showDashboard] = React.useState(true);
  // const [lstDashboard, setLstDashBoard] = React.useState([]);

  const [modulesList, setModulesList] = React.useState([]);
  const [Upload, setUpload] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);

  async function GetAllAssignRights() {
    console.log("In Get Assign Rights");

    setShowLoader(true);
    let societyCode = localStorage.getItem("societyCode");
    await makeGetRequest("asignrights/getbysocietycode/" + societyCode)
      .then((response) => {
        console.log(response);
        if (response.status == "201") {
          const data = response.data.data;

          if (data != undefined) {
            console.log("FUnction ", data.lst_modules);
            console.log(data.lst_modules.length);

            setModulesList([]);
            for (var i = 0; i < data.lst_modules.length; i++) {
              console.log("isAccess ", data.lst_modules[i].isAccess);
              if (data.lst_modules[i].isAccess)
                modulesList.push(data.lst_modules[i].module_name);
            }
            setModulesList(modulesList);
            console.log("Modules List ", modulesList);
            localStorage.setItem("ModulesList", modulesList);
          } else {
            GetAllAssignRights();
          }
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const [userType, setUserType] = React.useState("");
  React.useEffect(() => {
    setUserType(localStorage.getItem("userType"));

    // let isBuildingConfigured= localStorage.getItem("buildingConfigured");
    // alert("isBuildingConfigured ",isBuildingConfigured)

    if (
      (localStorage.getItem("userType") == "SocietyAdmin" || localStorage.getItem("userType") === "Admin Owner") &&
      sessionStorage.getItem("schema")
    ) {
      let lst = localStorage.getItem("ModulesList");
      console.log(lst);
      if (lst) {
        let newModulesLst = lst.split(",");
        setModulesList(newModulesLst);
      } else GetAllAssignRights();
    }
    setSelectedIndex(localStorage.getItem("selectedIndex"));
  }, [Upload]);

  return (
    <>
      <div className="forSlide">
        <div className="logoTop responsiveLogo">
          <ArrowForwardIcon className="menuBt" onClick={menuSlide} />
          {(userType == "SocietyAdmin" || userType == "Admin Owner") ? (
            <span className="logoHeading">Society Admin</span>
          ) : (
            <span className="logoHeading">Society Super Admin</span>
          )}
        </div>

        <div className="leftMain">
          <div className="logoTop">
            <MenuOutlinedIcon className="menuBt" onClick={menuSlide} />
            {(userType == "SocietyAdmin" || userType == "Admin Owner") ? (
              <span className="logoHeading">Society Admin</span>
            ) : (
              <span className="logoHeading">Society Super Admin</span>
            )}
          </div>

          <List
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
            component="nav"
            aria-labelledby="nested-list-subheader"
          >
            <ListItem
              style={{ padding: 0 }}
              className={
                localStorage.getItem("selectedIndex") == 0 ? "selectedMenu" : ""
              }
              onClick={(event) => handleListItemClick(event, 0)}
            >
              {showDashboard && localStorage.getItem("societyCode") ? (
                <ListItemButton onClick={() => navigate("/Dashboard")}>
                  <ListItemText onClick={leftPnlClose}>Dashboard</ListItemText>
                </ListItemButton>
              ) : (
                <ListItemButton onClick={() => navigate("/allsociety")}>
                  <ListItemText onClick={leftPnlClose}>Dashboard</ListItemText>
                </ListItemButton>
              )}
            </ListItem>

            {showConfigureSociety && localStorage.getItem("societyCode") ? (
              <ListItem
                style={{ padding: 0 }}
                className={
                  localStorage.getItem("selectedIndex") == 1
                    ? "selectedMenu"
                    : ""
                }
                onClick={(event) => handleListItemClick(event, 1)}
              >
                <ListItemButton onClick={() => navigate("/BuildingYes")}>
                  <ListItemText onClick={leftPnlClose}>
                    Configure Society
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}

            {modulesList.includes("Resident Management") ? (
              <ListItem
                style={{ padding: 0 }}
                className={
                  localStorage.getItem("selectedIndex") == 2
                    ? "selectedMenu"
                    : ""
                }
                onClick={(event) => handleListItemClick(event, 2)}
              >
                <ListItemButton
                  onClick={() => navigate("/ResidentManagement2")}
                >
                  <ListItemText onClick={leftPnlClose}>
                    Resident Management
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            ) : (
              <> </>
            )}

            {modulesList.includes("Apartment History") ? (
              <ListItem
                style={{ padding: 0 }}
                className={
                  localStorage.getItem("selectedIndex") == 11
                    ? "selectedMenu"
                    : ""
                }
                onClick={(event) => handleListItemClick(event, 11)}
              >
                <ListItemButton onClick={() => navigate("/ApartmentHistory")}>
                  <ListItemText onClick={leftPnlClose}>
                    {localStorage.getItem("buildingCnt") > 0 ? (
                      <>Apartment History</>
                    ) : (
                      <>Bunglow History</>
                    )}
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}

            {modulesList.includes("Guards And Security") ? (
              <>
                <ListItem
                  style={{ padding: 0 }}
                  className={
                    localStorage.getItem("selectedIndex") == 3
                      ? "selectedMenu"
                      : ""
                  }
                  onClick={(event) => handleListItemClick(event, 3)}
                >
                  <ListItemButton onClick={handleClick}>
                    <ListItemText>Guards & Security</ListItemText>
                    {open ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                </ListItem>

                <Collapse in={open} timeout="auto" unmountOnExit>
                  {/* <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => navigate("/Agencies")}
                >
                  <ListItemText onClick={leftPnlClose}>- Agencies</ListItemText>
                </ListItemButton>
              </List> */}
                  <List component="div" disablePadding>
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => navigate("/Guards")}
                    >
                      <ListItemText onClick={leftPnlClose}>
                        - Guards
                      </ListItemText>
                    </ListItemButton>
                  </List>
                  <List component="div" disablePadding>
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => navigate("/ConfigureSecuritySpots")}
                    >
                      <ListItemText onClick={leftPnlClose}>
                        - Configure Security Spots
                      </ListItemText>
                    </ListItemButton>
                  </List>
                  <List component="div" disablePadding>
                    <ListItemButton
                      sx={{ pl: 4 }}
                      onClick={() => navigate("/GuardAssignment")}
                    >
                      <ListItemText onClick={leftPnlClose}>
                        - Guard Assignment
                      </ListItemText>
                    </ListItemButton>
                  </List>
                </Collapse>
              </>
            ) : (
              <></>
            )}

            {modulesList.includes("Visitor Management") ? (
              <ListItem
                style={{ padding: 0 }}
                className={
                  localStorage.getItem("selectedIndex") == 4
                    ? "selectedMenu"
                    : ""
                }
                onClick={(event) => handleListItemClick(event, 4)}
              >
                <ListItemButton
                  onClick={() => navigate("/VisitorsManagement2")}
                >
                  <ListItemText onClick={leftPnlClose}>
                    Visitor Management
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}

            {modulesList.includes("Commitee Members") ? (
              <ListItem
                style={{ padding: 0 }}
                className={
                  localStorage.getItem("selectedIndex") == 6
                    ? "selectedMenu"
                    : ""
                }
                onClick={(event) => handleListItemClick(event, 6)}
              >
                <ListItemButton
                  onClick={() => navigate("/CommitteeManagement")}
                >
                  <ListItemText onClick={leftPnlClose}>
                    Committee Members
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}
            {modulesList.includes("Invoice Management") ? (
              <ListItem
                style={{ padding: 0 }}
                className={
                  localStorage.getItem("selectedIndex") == 7
                    ? "selectedMenu"
                    : ""
                }
                onClick={(event) => handleListItemClick(event, 7)}
              >
                <ListItemButton onClick={handleClick5}>
                  <ListItemText>Manage Invoice</ListItemText>
                  {open5 ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}

            <Collapse in={open5} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => navigate("/InvoiceListing")}
                >
                  <ListItemText onClick={leftPnlClose}>
                    - Create Invoice
                  </ListItemText>
                </ListItemButton>
              </List>

              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => navigate("/InvoiceReports")}
                >
                  <ListItemText onClick={leftPnlClose}>
                    - Invoice Reports
                  </ListItemText>
                </ListItemButton>
              </List>

              
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => navigate("/InvoiceSettings")}
                >
                  <ListItemText onClick={leftPnlClose}>- Settings</ListItemText>
                </ListItemButton>
              </List>
            </Collapse>

            {modulesList.includes("Tickets") ? (
              <ListItem
                style={{ padding: 0 }}
                className={
                  localStorage.getItem("selectedIndex") == 8
                    ? "selectedMenu"
                    : ""
                }
                onClick={(event) => handleListItemClick(event, 8)}
              >
                <ListItemButton onClick={() => navigate("/Tickets")}>
                  <ListItemText onClick={leftPnlClose}>
                    Support Tickets
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}

            {modulesList.includes("Manage SOS") ? (
              <ListItem
                style={{ padding: 0 }}
                className={
                  localStorage.getItem("selectedIndex") == 9
                    ? "selectedMenu"
                    : ""
                }
                onClick={(event) => handleListItemClick(event, 9)}
              >
                <ListItemButton onClick={() => navigate("/ManageSOS")}>
                  <ListItemText onClick={leftPnlClose}>Manage SOS</ListItemText>
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}


                  {/* <ListItemButton onClick={handleClick3}>
                    <ListItemText>Service Providers</ListItemText>
                    {open3 ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton> */}
                  <Collapse in={open3} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => navigate("/AllServiceProviders")}
                      >
                        <ListItemText onClick={leftPnlClose}>
                          - All Service Providers
                        </ListItemText>
                      </ListItemButton>
                    </List>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => navigate("/InOutLogs")}
                      >
                        <ListItemText onClick={leftPnlClose}>
                          - Service Provider In/Out Logs
                        </ListItemText>
                      </ListItemButton>
                    </List>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => navigate("/ActiveServiceProviders")}
                      >
                        <ListItemText onClick={leftPnlClose}>
                          - Active Providers
                        </ListItemText>
                      </ListItemButton>
                    </List>

                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => navigate("/RejectedProviders")}
                      >
                        <ListItemText onClick={leftPnlClose}>
                          - Rejected Providers
                        </ListItemText>
                      </ListItemButton>
                    </List>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => navigate("/VerificationInProgress")}
                      >
                        <ListItemText onClick={leftPnlClose}>
                          - Verification In Progress
                        </ListItemText>
                      </ListItemButton>
                    </List>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => navigate("/NewProvider")}
                      >
                        <ListItemText onClick={leftPnlClose}>
                          - New Providers
                        </ListItemText>
                      </ListItemButton>
                    </List>
                    <List component="div" disablePadding>
                      <ListItemButton
                        sx={{ pl: 4 }}
                        onClick={() => navigate("/ServiceProviderHistory")}
                      >
                        <ListItemText onClick={leftPnlClose}>
                          - Service Provider History
                        </ListItemText>
                      </ListItemButton>
                    </List>
                  </Collapse>
                

            {(localStorage.getItem("userType") === "SocietyAdmin" || localStorage.getItem("userType") === "Admin Owner" || 
              localStorage.getItem("userType") === "SuperAdmin") &&
              localStorage.getItem("societyName") !== null && (
                <ListItem
                  style={{ padding: 0 }}
                  className={
                    localStorage.getItem("selectedIndex") == 14
                      ? "selectedMenu"
                      : ""
                  }
                  onClick={(event) => handleListItemClick(event, 14)}
                >
                  <ListItemButton onClick={() => navigate("/TechSupport")}>
                    <ListItemText onClick={leftPnlClose}>
                      Tech Support
                    </ListItemText>
                  </ListItemButton>
                </ListItem>
              )}
          
            <ListItem
              style={{ padding: 0 }}
              className={
                localStorage.getItem("selectedIndex") == 13
                  ? "selectedMenu"
                  : ""
              }
              onClick={(event) => handleListItemClick(event, 13)}
            >
              <ListItemButton onClick={() => navigate("/Aboutus")}>
                <ListItemText onClick={leftPnlClose}>About Us</ListItemText>
              </ListItemButton>
            </ListItem>

            {userType == "SuperAdmin" ? (
              <>
                <ListItem
                  style={{ padding: 0 }}
                  className={
                    localStorage.getItem("selectedIndex") == 10
                      ? "selectedMenu"
                      : ""
                  }
                  onClick={(event) => handleListItemClick(event, 10)}
                >
                  <ListItemButton onClick={() => navigate("/AssignRights")}>
                    <ListItemText onClick={leftPnlClose}>
                      Assign Rights
                    </ListItemText>
                  </ListItemButton>
                </ListItem>

                <ListItem
                  style={{ padding: 0 }}
                  className={
                    localStorage.getItem("selectedIndex") == 11
                      ? "selectedMenu"
                      : ""
                  }
                  onClick={(event) => handleListItemClick(event, 11)}
                >
                  <ListItemButton onClick={() => navigate("/SocietyAdmin")}>
                    <ListItemText onClick={leftPnlClose}>
                      Society Admin
                    </ListItemText>
                  </ListItemButton>
                </ListItem>
              </>
            ) : (
              <></>
            )}

            <ListItemButton onClick={() => logoutUser()}>
              <ListItemText>Log Out</ListItemText>
            </ListItemButton>

            {/* <ListItemButton
              onClick={() => navigate("/ApplicationDevelopement")}
            >
              <ListItemText onClick={leftPnlClose}>
                Application Dev... 
              </ListItemText>
            </ListItemButton> */}

            {/* <ListItemButton onClick={handleClick4}>
              <ListItemText>Reports</ListItemText>
              {open4 ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open4} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => navigate("/ResidentReport")}
                >
                  <ListItemText onClick={leftPnlClose}>
                    - Residents
                  </ListItemText>
                </ListItemButton>
              </List>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => navigate("/VisitorsReport")}
                >
                  <ListItemText onClick={leftPnlClose}>- Visitors</ListItemText>
                </ListItemButton>
              </List>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => navigate("/ServiceProviderReport")}
                >
                  <ListItemText onClick={leftPnlClose}>
                    - Report Service Prov..
                  </ListItemText>
                </ListItemButton>
              </List>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() => navigate("/SecurityGuardsReport")}
                >
                  <ListItemText onClick={leftPnlClose}>
                    - Security Guards
                  </ListItemText>
                </ListItemButton>
              </List>
            </Collapse> */}

            {/* <ListItemButton>
              <ListItemText onClick={leftPnlClose}>Settings</ListItemText>
            </ListItemButton> */}
          </List>
        </div>
      </div>
      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default Left;
